// import { datadogRum } from '@datadog/browser-rum'; //uncomment and add back lib if we want web rum again

import noop from 'utils/noop';

// export const rumWrapperStartView = (key: string, _name: string, _context?: object) =>
//   datadogRum.startView(key);

export const rumWrapperStartView = noop;

// this isn't implemented for web in DD for some reason. not a big issue since web is insignificant.
export const rumWrapperStopView = (key: string) => {};
